import { FC, useEffect } from "react";
import { User, Home } from "lucide-react";
import { useOktaAuth } from "@okta/okta-react";
import { oktaConfig } from "@/config/oktaConfig";
import Logo from "../../assets/images/logo-tmhcc.svg";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "../ui/dropdown-menu";

import "./Header.css";
import { useLocation, useNavigate } from "react-router-dom";

const Header: FC = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isAuthenticated = !!authState?.isAuthenticated;

  useEffect(() => {
    const storeOktaUserId = async () => {
      if (!isAuthenticated) return;

      try {
        const user = await oktaAuth.getUser();
        if (user) {
          sessionStorage.setItem("userId", String(user.email));
        }
      } catch {
        sessionStorage.removeItem("userId");
      }
    };

    storeOktaUserId();
  }, [isAuthenticated, oktaAuth]);

  const handleLogOut = async () => {
    try {
      sessionStorage.clear();
      localStorage.clear();

      await oktaAuth.signOut({
        postLogoutRedirectUri: oktaConfig.postLogoutRedirectUri
      });

      navigate("/login");
    } catch {
      navigate("/login");
    }
  };

  const isHomePage = location.pathname === "/home" || location.pathname === "/home/";

  return (
    <header className="app-header">
      <div className="letf-header-sec">
        <div className="logo-svg">
          <img className="logo-svg-img" src={Logo} alt="logo" />
        </div>
        <span className="__divider"></span>
        <h1 className="app-title">CDP Operations</h1>
          <span className="__divider"></span>
        <h1 className="app-title">{import.meta.env.VITE_APP_ENV}</h1>
      </div>
      {isAuthenticated && (
        <div className="user-icon flex items-center gap-3">
          {!isHomePage && (
            <div
              className="icon-round h-8 w-8 rounded-full bg-[#dce7f4] flex items-center justify-center cursor-pointer"
              onClick={() => navigate("/home")}
              title="Home"
              aria-label="Go to Home"
            >
              <Home size={14} />
            </div>
          )}

          <DropdownMenu>
            <DropdownMenuTrigger className="user-icon-round" asChild>
              <div className="icon-round h-8 w-8 rounded-full bg-[#dce7f4] flex items-center justify-center cursor-pointer">
                <User size={14} />
              </div>
            </DropdownMenuTrigger>

            <DropdownMenuContent side="bottom" align="end" className="w-44">
              <DropdownMenuItem onSelect={handleLogOut}>
                Logout
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}
    </header>
  );
};

export default Header;